<template>
  <div v-click-out="closeOptionsDropdown" class="header-search">
    <div class="header-search__main">
      <div class="header-search__inputs-wrap">
        <div class="header-search__inputs-inner">
          <label class="header-search__input-item">
            <div class="header-search__input-item-title  d-none  d-sm-block">
              {{ $tHeader('Search') }}
            </div>
            <input v-model="inputValue"
                   type="search"
                   :placeholder="$tHeader('The Search')"
                   @keypress.enter.prevent="onSearch"
                   @keydown="checkSpeed(inputValue)"
                   class="header-search__search-input">
          </label>
          <div class="header-search__input-item header-search__select-wrap">
            <div class="header-search__input-item-title  d-none  d-sm-block">
              {{ $tHeader('Region') }}
            </div>
            <SRegion v-model="region"
                     @blur="saveRegion(region)"
                     class="header-search__select _white"/>
          </div>
        </div>
      </div>
      <button @click.prevent="onSearch"
              class="header-search__submit-btn base-btn base-btn--green   d-sm-none  specific-header-search">
        <BaseSvg name="ico-loupe"
                 width="1.3rem"
                 height="1.3rem"
        />
      </button>
      <button v-if="hide && windowSizeMixin.width > WINDOW_SIZE_SM" type="button"
              @click.prevent="toggleOptionsDropdown"
              :class="isOptionsOpen ? '_open' : '_close'"
              class="header-search__filter-btn base-btn">
        <BaseSvg name="ico-settings"
                 width="1.7rem"
                 height="1.5rem"
                 class="header-search__filter-btn-ico  _open"/>
        <BaseSvg name="ico-close"
                 class="header-search__filter-btn-ico  _close  d-none  d-md-block"/>

        <span class="d-none  d-sm-flex">{{ $tHeader('Advanced Search') }}</span>
      </button>

    </div>
    <div v-if="hide && windowSizeMixin.width > WINDOW_SIZE_XS && windowSizeMixin.width <= WINDOW_SIZE_SM"
         class="header-search__filter-btn-wrap">
      <button type="button"
              @click.prevent="toggleOptionsDropdown"
              :class="isOptionsOpen ? '_open' : '_close'"
              class="header-search__filter-btn base-btn">
        <BaseSvg name="ico-settings"
                 width="1.7rem"
                 height="1.5rem"
                 class="header-search__filter-btn-ico  _open"/>
        <BaseSvg name="ico-close"
                 class="header-search__filter-btn-ico  _close  d-none  d-md-block"/>

        <span class="d-none  d-sm-flex">{{ $tHeader('Advanced Search') }}</span>
      </button>
    </div>
    <v-slide-toggle v-else-if="hide && windowSizeMixin.width <= WINDOW_SIZE_XS"
                    :active="!isOptionsOpen"
                    class="header-search__filter-btn-wrap">
      <button v-if="hide"
              type="button"
              @click.prevent="toggleOptionsDropdown"
              :class="isOptionsOpen ? '_open' : '_close'"
              class="header-search__filter-btn base-btn">
        <BaseSvg name="ico-settings"
                 width="1.7rem"
                 height="1.5rem"
                 class="header-search__filter-btn-ico  _open"/>
        <BaseSvg name="ico-close"
                 class="header-search__filter-btn-ico  _close  d-none  d-md-block"/>

        <span class="d-none  d-sm-flex">{{ $tHeader('Advanced Search') }}</span>
      </button>
    </v-slide-toggle>
    <transition v-if="windowSizeMixin.width > WINDOW_SIZE_MD" name="dropdown">
      <div v-if="isOptionsOpen"
           class="header-search__options-dropdown  container">
        <div class="header-search__options-wrap  container-inner">
          <button @click.prevent="onClickCloseOptionsDropdown"
                  class="header-search__options-close  d-md-none  d-xs-flex">
            <BaseSvg name="ico-close"/>
          </button>
          <SearchOptions ref="options"
                         v-model="additionalOptions"
                         class="header-search__options"/>
        </div>
      </div>
    </transition>
    <v-slide-toggle v-else
                    :active="isOptionsOpen"
                    :class="isOptionsOpen ? '_open' : '_close'"
                    class="header-search__options-dropdown  container">
      <div class="header-search__options-wrap  container-inner">
        <button @click.prevent="onClickCloseOptionsDropdown"
                class="header-search__options-close  d-md-none  d-xs-flex">
          <BaseSvg name="ico-close"/>
        </button>
        <SearchOptions ref="options"
                       v-model="additionalOptions"
                       :canLoad="isOptionsOpen"
                       class="header-search__options"/>
      </div>
    </v-slide-toggle>
    <button type="button"
            @click.prevent="onSearch"
            class="header-search__submit-btn  base-btn  base-btn--green   d-none  d-sm-flex  specific-header-search">
      <BaseSvg name="ico-loupe"/>
      <span>{{ $tHeader('Find a job') }}</span>
    </button>
  </div>
</template>

<script>
  import windowSizeMixin from '../mixins/windowSizeMixin'
  import searchMixin from '../mixins/searchMixin'
  import {WINDOW_SIZE_MD, WINDOW_SIZE_SM, WINDOW_SIZE_XS} from '@/constants/windowSizes'
  import SearchOptions from './SearchOptions'
  import SRegion from './loadingSelects/SRegion'
  // import {http} from '../axios'

  export default {
    name: "HeaderSearch",
    mixins: [windowSizeMixin, searchMixin],
    components: {
      SearchOptions,
      SRegion
    },
    data() {
      return {
        lastTime: 0,
        time: 0,
        total: 0,
        keys: 0,
        cpm: 0,
        wpm: 0,
        hide: false,

        WINDOW_SIZE_MD,
        WINDOW_SIZE_SM,
        WINDOW_SIZE_XS,
      }
    },
    computed: {},
    methods: {
      afterSearch() {
        this.closeOptionsDropdown()
      },
      onClickCloseOptionsDropdown() {
        this.isOptionsOpen = false
      },
      toggleOptionsDropdown() {
        this.isOptionsOpen = !this.isOptionsOpen
      },
      closeOptionsDropdown() {
        this.isOptionsOpen = false
      },
      onSearch() {
        if (this.inputValue.length !== 0 && this.cpm !== 0 && this.wpm !== 0) {
          let str = `Search query: ${this.inputValue}. Typing speed crm: ${this.cpm} chs/min, wpm: ${this.wpm} words/min`;
          this.$store.dispatch('sendAlert', {
            type: 'search',
            title: str,
            query: `search_query=${this.inputValue}`
          })
        }

        this.onSearchMixin()
        this.cpm = 0
        this.wpm = 0
      },
      checkSpeed(val) {
        this.time = new Date().getTime();
        if (this.lastTime !== 0) {
          this.keys++;
          this.total += this.time - this.lastTime;

          this.cpm = Math.round(this.keys / this.total * 6000)
          this.wpm = Math.round(val.split(" ").length / this.total * 6000)
        }
        this.lastTime = this.time
      },
      saveRegion(val) {
        console.log(val)
      }
    },
    created() {
      // this.loadDirections()
    },
    watch: {}
  }
</script>

<style>

</style>
